import { render, staticRenderFns } from "./DriverScore.vue?vue&type=template&id=6019d152&"
import script from "./DriverScore.vue?vue&type=script&lang=js&"
export * from "./DriverScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports